import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { setItem, getItem } from '../../../utility/LocalStorage'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorLocationProvince = () => {
  const { t } = useTranslation()
  const listProvince = useCallback(
    (callback, loadingCallback) => {
      const list_province = getItem('list-province')
      if (list_province != null && list_province.length > 0) {
        callback(list_province)
      } else {
        ApiService.jsonRequest(
          '/master-province/list',
          {
            country_uid: process.env.REACT_APP_COUNTRY_UID,
          },
          (response) => {
            if (response.status_code === 200) {
              setItem('list-province', response.data)
              callback(response.data)
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.message}`),
                timer: 2000,
              })
            }
          },
        )
      }
      loadingCallback(false)
    },
    [t],
  )

  return { listProvince }
}

export default InteractorLocationProvince
